// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"af3dfc8e","732":"5c420af4","977":"51cd45a0"}[chunkId] + ".chunk.js";
};